import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'root/view/base';

var Asana_Send = View.extend({
    projects: null,
    users: null,

    project_id: '',
    user_id   : '',

    form_value : {
        title: ''
    },

    events: {
        'click .dropdown-project li.project' : 'onSelectProject',
        'click .dropdown-user li'            : 'onSelectUser',
        'submit form'                        : 'onSubmit',
        'click .reconnect'                   : 'onReconnect'
    },

    dom_handlers: {
        onSelectProject: function(e) {
            var project_old = this.searchProject(this.project_id);

            this.project_id = $(e.currentTarget).data('id');
            this.renderProjects();

            var project_new = this.searchProject(this.project_id);

            if (project_old.workspace !== project_new.workspace) {
                this.user_id = '';
                this.users.forEach(function(user) {
                    if (user.workspace === project_new.workspace && !this.user_id) {
                        this.user_id = user.id;
                    }
                }.bind(this));

                this.renderUsers();
            }
        },

        onSelectUser: function(e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            this.user_id = $(e.currentTarget).data('id');
            this.renderUsers();
        },

        onReconnect: function(e) {
            var connected_app = Cache.connected_app_oauth.get(Cache.integration_asana.findWhere({project_id: this.model.get('project_id')})?.get('app_id') || 0);

            if (connected_app) {
                Modals.reconnectConnectedApp(connected_app.get('app_type'), connected_app, () => {
                    Modals.sendToAsana(this.model.id);
                });
            } else {
                window.parent.location = '/account/connected_app';
            }
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            if (!this.project_id) {
                UI.error('Please select a Project');
                return;
            }

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            this.$el.find('.mask-light').show();
            this.$el.find('.progress-loader').width('0%').show();
            var progress = 0;
            var timeout = setInterval(function() {
                progress = Math.min(90, progress + Math.random() * 5);
                this.$el.find('.progress-loader').width(progress + '%');
            }.bind(this), 50);

            Cache.app.request({
                action: 'integration/sendFeedbackToAsana',
                context: this,
                data: _.extend(form_data, {
                    feedback_id : this.model.get('id'),
                    project_id  : this.project_id,
                    title       : form_data.title,
                    description : form_data.description,
                    assignee    : this.user_id,
                    due_date    : form_data.due_date
                }),
                success: function(response) {
                    this.model.set('asana_url', response.asana_url);

                    setTimeout(function() {
                        UI.success('Task created in Asana');
                        this.trigger('submit:success');
                    }.bind(this), 800);  // wait for animation to finish
                },
                complete: function() {
                    this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');

                    clearInterval(timeout);
                    this.$el.find('.progress-loader').width('100%');
                }
            });
        }
    },

    initialize: function() {
        this.form_value  = {
            title: ''
        };

        if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
            this.title = 'Feedback for ' + this.model.get('page');
        } else {
            this.title = 'Feedback #' + Util.padLeft(this.model.id, '000000');
        }

        if (this.model.get('title')) {
            this.form_value.title = this.model.get('title');
        }
    },

    loadSendOptions: function() {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type : 'asana',
                project_id: this.model.get('project_id')
            },
            context: this,
            success: function(response) {
                if (response.projects && response.projects.length) {
                    var default_project_id = Cache.integration_asana.findWhere({project_id: this.model.get('project_id')})?.get('asana_project_id') || '';

                    this.projects = response.projects;
                    this.users    = response.users;

                    this.project_id = this.searchProject(default_project_id) ? default_project_id : response.projects[0].id;

                    if (response.users && response.users.length) {
                        this.user_id = response.users[0].id;
                    }

                    this.renderProjects();
                    this.renderUsers();
                } else {
                    var message = '<div class="error-dialog padding-30">' +
                                        '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                                        '<h3>Authentication failed</h3>' +
                                        '<p class="info">We couldn\'t connect to your Asana account.</p>' +
                                        (Cache.app.isAdmin() ?
                                        '<button class="reconnect primary medium">Reconnect Asana</button>' +
                                        '<div class="divider-20"></div>' : '') +
                                    '</div>';

                    this.$el.html(message);
                }
            },
            complete: function() {
                this.$el.find('form button:submit').prop('disabled', false);
            }
        });
    },

    searchProject: function(project_id) {
        var result = false;

        if (this.projects) {
            this.projects.forEach(function(project) {
                if (project.id == project_id) {
                    result = project;
                }
            });
        }

        return result;
    },

    searchUser: function(user_id) {
        var result = false;

        if (this.users) {
            this.users.forEach(function(user) {
                if (user.id == user_id) {
                    result = user;
                }
            });
        }

        return result;
    },

    renderProjects: function() {
        var project_items = '';

        if (this.projects) {
            var grouped_projects = {};

            this.projects.forEach(function(project) {
                if (typeof grouped_projects[project.workspace] === 'undefined') {
                    grouped_projects[project.workspace] = [];
                }

                grouped_projects[project.workspace].push(project);
            }.bind(this));

            var count = 0;
            _.each(grouped_projects, function(projects, workspace) {
                project_items += '<li class="dropdown-title margin-left-0' + (count > 0 ? ' margin-top-4' : '') + '">' + Util.htmlEntities(workspace) + '</li>';

                projects.forEach(function(project) {
                    project_items += '<li class="project' + (this.project_id == project.id ? ' selected' : '') + '" data-id="' + project.id + '"' + '>' +
                                            Util.htmlEntities(project.name) +
                                        '</li>';
                }.bind(this));

                count++;
            }, this);
        }

        var project_selected = this.searchProject(this.project_id);

        var html = '<div class="field-label">Project <i class="fas fa-asterisk"></i></div>' +
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-project" data-append="true">' +
                        '<button type="button" class="dropdown-select">' +
                            Util.htmlEntities(project_selected.name) +
                        '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by project name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select">' + project_items + '</ul>' +
                        '</div>' +
                    '</div>';

        this.$el.find('.region-projects').html(html);
    },

    renderUsers: function() {
        var user_items = '';

        if (this.users) {
            var project_selected = this.searchProject(this.project_id);
            var workspace = null;

            if (project_selected) {
                workspace = project_selected['workspace'];
            }

            this.users.forEach(function(user) {
                if (user.workspace === workspace) {
                    user_items += '<li data-id="' + user.id + '"' + (this.user_id == user.id ? ' class="selected"' : '') + '>' +
                                    Util.htmlEntities(user.name) +
                                '</li>';
                }
            }.bind(this));
        }

        var user_selected = this.searchUser(this.user_id);

        var html = '<div class="field-label">Assignee <i class="fas fa-asterisk"></i></div>' +
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-user" data-append="true">' +
                        '<button type="button" class="dropdown-select">' +
                            (user_selected ? Util.htmlEntities(user_selected.name) : '<span class="placeholder-text">No assignee selected</span>') +
                        '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by user name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select">' + (user_items || '<li class="disabled">No assignees</li>') + '</ul>' +
                        '</div>' +
                    '</div>';

        this.$el.find('.region-users').html(html);
    },

    render: function() {
        var content = '';

        content += '<div class="progress-loader"></div>';
        content += '<div class="mask-light" style="display:none;"></div>';

        content += '<form class="form-fluid">' +
                        '<div class="modal-integration-innerscroll">' +
                            '<div class="row region-projects">' +
                                '<div class="field-label">Project <i class="fas fa-asterisk"></i></div>' +
                                '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Title</div>' +
                                '<input type="text" name="title" maxlength="255" class="solid compact" placeholder="' + Util.htmlEntities(this.title) + '">' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Description</div>' +
                                '<textarea name="description" class="solid compact" rows="3"></textarea>' +
                            '</div>' +
                            '<div class="row region-users">' +
                                '<div class="field-label">Assignee <i class="fas fa-asterisk"></i></div>' +
                                '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Due Date</div>' +
                                '<input type="date" name="due_date" class="solid compact">' +
                            '</div>' +
                        '</div>' +

                        '<div class="modal-integration-innerscroll-footer">' +
                            '<button type="submit" class="primary" disabled>Send</button>' +
                        '</div>' +
                    '</form>';

        this.$el.html(content);

        if (this.form_value.title) {
            Form.setData(this.$el.find('form'), {
                title: this.form_value.title
            });
        }

        if (this.model.get('due_date')) {
            Form.setData(this.$el.find('form'), {
                due_date: Util.moment(this.model.get('due_date'), 'YYYY-MM-DD', false, false)
            });
        }

        if (!this.send_options) {
            this.loadSendOptions();
        }

        return this;
    }
});

export default Asana_Send;